module.exports = __webpack_public_path__ + "img/logo_dark.dab6f87c.png";